import * as React from 'react'

import AddContractByTemplateColor from '../../../../../assets/icons_new/AddContractByTemplateColor.svg'
import AddAnnexColor from '../../../../../assets/icons_new/AddAnnexColor.svg'
import { useModals } from '@/modules/drivers/stores/modalsStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
const ContractActions = () => {
  const { t } = useLocalize()
  const { setIsCreateContractOpen, setIsCreateAnnexOpen } = useModals()
  const ACTIONS = [
    {
      label: t('contract.add-contract'),
      onClick: () => setIsCreateContractOpen(true),
      icon: AddContractByTemplateColor,
      disabled: false
    },
    {
      label: t('driverModule.add-annex'),
      onClick: () => setIsCreateAnnexOpen(true),
      icon: AddAnnexColor,
      disabled: false
    },
    // {
    //   label: 'Dodaj umowę z szablonu',
    //   onClick: () => console.log('Opcja 2'),
    //   icon: AddContractColor,
    // },
    // {
    //   label: 'Dodaj aneks',
    //   onClick: () => setIsAnnexOpen(true),
    //   icon: AddAnnexColor,
    //   disabled: selectedGroup.ids.length > 1,
    // },
    // {
    //   label: 'Dodaj aneks z szablonu',
    //   onClick: () => console.log('Opcja 4'),
    //   icon: AddAnnexByTemplateColor,
    // },
  ]

  return (
    <div className="tw-absolute tw-mt-4 tw-flex tw-min-w-[230px] tw-flex-col tw-gap-1.5 tw-rounded tw-border tw-bg-white tw-p-1.5">
      {ACTIONS.map((action) => {
        return (
          <button
            key={action?.label}
            disabled={action?.disabled}
            onClick={action?.onClick}
            className={`tw-flex tw-gap-2 tw-rounded tw-p-1.5 hover:tw-bg-base-200 ${action?.disabled ? 'tw-cursor-not-allowed tw-opacity-50 hover:tw-bg-white' : 'tw-cursor-pointer'}`}
          >
            <img src={action?.icon} />
            <p className="tw-color-content-base tw-text-sm tw-font-medium">
              {action?.label}
            </p>
          </button>
        )
      })}
    </div>
  )
}

export default ContractActions
